var React = require('react');

function LinkedinSquare (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M.025 1.433C.025.642.686 0 1.501 0h17.013c.815 0 1.476.642 1.476 1.433v17.135c0 .79-.66 1.432-1.476 1.432H1.501c-.815 0-1.476-.641-1.476-1.432V1.432z","key":0}),React.createElement("path",{"fill":"#fff","d":"M6.076 16.744V7.713H3.061v9.03h3.015zM4.57 6.48c1.051 0 1.706-.694 1.706-1.56-.02-.887-.655-1.56-1.686-1.56-1.032 0-1.706.673-1.706 1.56 0 .866.654 1.56 1.666 1.56h.02zm3.176 10.264h3.015V11.7c0-.27.02-.54.1-.732.218-.54.714-1.098 1.547-1.098 1.09 0 1.527.828 1.527 2.042v4.83h3.016v-5.177c0-2.774-1.488-4.065-3.472-4.065-1.626 0-2.34.905-2.737 1.521h.02V7.713H7.745c.04.847 0 9.031 0 9.031z","key":1})]);
}

LinkedinSquare.defaultProps = {"fill":"none","viewBox":"0 0 20 20"};

module.exports = LinkedinSquare;

LinkedinSquare.default = LinkedinSquare;
